import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { AccessConstants } from '../../../../core/constants/access-constants';
import { AuthenticatedUser } from '../../../../core/models/authenticated-user';
import { UserStateService } from '../../../user/shared/services/user-state/user-state.service';
import { AccountingReviewReportComponent } from './components/accounting-review-report/accounting-review-report.component';
import { QuickbooksReportComponent } from './components/quickbooks-report/quickbooks-report.component';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatExpansionModule,
        QuickbooksReportComponent,
        AccountingReviewReportComponent,
    ],
})
export class ReportsComponent {
    private readonly userStateService = inject(UserStateService);
    private readonly authenticatedUser: AuthenticatedUser | null =
        this.userStateService.getUser();

    /**
     * Determines whether the QuickBooks report section should be displayed based on the authenticated user's role.
     *
     * @returns A boolean indicating whether the QuickBooks report section should be displayed.
     * @throws An error if the authenticated user is not available.
     */
    shouldDisplayQuickbooksReport(): boolean {
        this.guardAgainstMissingAuthenticatedUser();

        const userRole = this.authenticatedUser!.role;
        return AccessConstants.RolesThatCanAccessQuickbooksReports.includes(
            userRole,
        );
    }

    /**
     * Guards against the absence of an authenticated user.
     * If the authenticated user is not available, it throws an error.
     */
    private guardAgainstMissingAuthenticatedUser(): void {
        if (!this.authenticatedUser) {
            throw new Error('Authenticated user is not available.');
        }
    }
}
